import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { markdownToHtml } from "@perxis-auto/shared";
import { Disclaimer } from "@perxis-auto/ui-kit/lib/components/Disclaimer";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import { selectBenefits } from "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { BenefitDisclaimerEnum } from "../../../shared/types/benefits.js";
import styles from "./BenefitsFootnote.module.scss.js";
const renderBenefitFootnote = (benefitFootnote, type) => {
  const parsedHtml = markdownToHtml(benefitFootnote.text);
  switch (type) {
    case BenefitDisclaimerEnum.Text: {
      return /* @__PURE__ */ jsxs(
        Typography.Text,
        {
          level: "super-small",
          color: "dark-light",
          className: styles.benefitsFootnote__text,
          children: [
            /* @__PURE__ */ jsx("sup", { children: benefitFootnote.order }),
            " ",
            /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: parsedHtml } })
          ]
        },
        benefitFootnote.id
      );
    }
    case BenefitDisclaimerEnum.Paragraph:
    default: {
      return /* @__PURE__ */ jsxs(
        Typography.Paragraph,
        {
          level: "super-small",
          color: "dark-light",
          className: styles.benefitsFootnote__paragraph,
          children: [
            /* @__PURE__ */ jsx("sup", { children: benefitFootnote.order }),
            " ",
            /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: parsedHtml } })
          ]
        },
        benefitFootnote.id
      );
    }
  }
};
const BenefitsFootnote = withEnabledComponent(
  memo(function BenefitsFootnote2({ displayType, footnotes, ...props }) {
    if (!footnotes.length) {
      return null;
    }
    return /* @__PURE__ */ jsx(Disclaimer, { ...props, children: footnotes.map((footnote) => renderBenefitFootnote(footnote, displayType)) });
  }),
  selectBenefits
);
export {
  BenefitsFootnote
};
